import axios from 'axios';
import { installRequestId } from '../utils/requestId';
import { getMarketplaceApiBaseUrl } from './resolveApiBaseUrl';

const API_BASE_URL = process.env.REACT_APP_ITEMS_API_URL ||
  getMarketplaceApiBaseUrl() || 'http://localhost:8080/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});
installRequestId(api);

export const brandsAPI = {
  searchBrands: async (query = '', limit = 50) => {
    const params = new URLSearchParams();
    if (query) params.append('q', query);
    if (limit) params.append('limit', String(limit));
    const response = await api.get(`/public/brands/?${params.toString()}`);
    return response.data?.brands || [];
  },
};

export const EMPTY_BRAND_SELECTION = {
  brandId: null,
  brandName: null,
  isNoBrand: false,
  isLocalBrand: false,
};

export function isBrandSelectionComplete(selection, { required = true } = {}) {
  if (!required) return true;
  if (selection?.isLocalBrand) return Boolean(String(selection?.customBrandName || '').trim());
  return Boolean(selection?.brandId);
}

export function appendBrandFields(formData, selection) {
  if (!selection) return;
  if (selection.isLocalBrand && selection.customBrandName) {
    formData.append('custom_brand_name', String(selection.customBrandName).trim());
    formData.append('is_no_brand', 'false');
    return;
  }
  if (selection.brandId) {
    formData.append('brand_id', String(selection.brandId));
    formData.append('is_no_brand', 'false');
  }
}

export function brandSelectionError(selection, { required = true } = {}) {
  if (!required) return '';
  if (isBrandSelectionComplete(selection, { required })) return '';
  if (selection?.isLocalBrand) return 'Please enter the brand name.';
  return 'Please select a brand.';
}
